// Some API schemas serialize datetimes as NAIVE UTC strings ("2026-09-19T22:30:00", no Z: projects, maintenance,
// knowledge, customer profiles) while others end in "Z". `new Date(naive)` reads a naive string as LOCAL time, so an
// update at 22:30Z on the 19th (01:30 in Israel on the 20th) showed the 19th, and rows from both kinds sorted up to
// three hours out of order. Date-only values ("2026-09-20", a due date) are left alone.
export const asUtc = (iso) =>
  typeof iso === "string" && iso.includes("T") && !/(Z|[+-]\d\d:?\d\d)$/i.test(iso) ? iso + "Z" : iso;

export const parseUtc = (iso) => new Date(asUtc(iso));
